<div class="overlay"> </div>
<iframe src="https://demo.webgis.nl/nl/workspace/civity/map/dataplatform" frameborder="0" style="border:0"
  allowfullscreen></iframe>
<div fxlayout="column" fxlayoutalign="center center" ng-reflect-fx-layout="column" ng-reflect-fx-layout-align="center center" style="flex-direction: column; box-sizing: border-box; display: flex; place-content: center; align-items: center;">
  <i>This map is build with WGP from our partner&nbsp;<a href="https://www.nieuwlandgeo.nl/" target="_blank">Nieuwland</a></i>
</div>